import { motion } from "framer-motion";

const About = () => {
  return (
    // <section id="about" className="min-h-screen flex items-center justify-center bg-gray-100">
    <section id="about" className="md:h-screen min-h-screen flex flex-col justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
  
      <div className="container mx-auto px-8 text-center">
        {/* Animated Heading */}
        <motion.h2
          className="text-5xl font-extrabold text-gray-900 relative inline-block"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          About Me
          <span className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-600 to-purple-500 rounded-lg"></span>
        </motion.h2>

        {/* Animated Paragraph */}
        <motion.p
          className="mt-8 max-w-3xl mx-auto text-xl text-gray-700 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          I’m a Master’s student in Computer Science at the University of Southern California, focused on backend engineering, cloud systems, and applied AI.
          Before grad school, I worked at Deutsche Bank, where I designed and shipped scalable APIs and enterprise GenAI systems, including conversational AI platforms and LLM deployments on constrained infrastructure. 
          I’ve worked on everything from system design and performance optimization to safety and privacy guardrails for AI outputs.
          I enjoy building systems that scale cleanly, fail gracefully, and solve real problems.
        </motion.p>
      </div>
    </section>
  );
};

export default About;
